import React from 'react';

const Account = () => {
  return (
    <div id="account-return">
      <div id="account-container">
        <p id="account-title">
          ACCOUNTS GO HERE.
        </p>
        <br />
        <br />
        Delavega Autoplex uses Clearent for managing your account and payment history.
        <br />
        <a href="https://campus.clearent.com/login/">Login with Clearent here</a>

      </div>
    </div>
  )
}

export default Account;